
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minu/konto",
      function () {
        return require("private-next-pages/minu/konto/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minu/konto"])
      });
    }
  